import ViewTemplatesHome from "../views/ViewTemplatesHome.vue"
import ViewTemplatesWkhtml from "../views/ViewTemplatesWkhtml.vue"
import ViewTemplatesEmailMjml from "../views/ViewTemplatesEmailMjml.vue"
import ViewTemplatesNotification from "../views/ViewTemplatesNotification.vue"
import ViewTemplatesPdfDrawing from "../views/ViewTemplatesPdfDrawing.vue"
import ViewTemplatesSms from "../views/ViewTemplatesSms.vue"
import ViewTemplatesDynamic from "../views/ViewTemplatesDynamic.vue"
import ViewTemplatesFunction from "../views/ViewTemplatesFunction.vue"

export default [
	{
		path: "/templates",
		component: ViewTemplatesHome,
		name: "ViewTemplatesHome",
		meta: {}
	},
	{
		path: "/templates/html-pdf/:id",
		component: ViewTemplatesWkhtml,
		props: true,
		name: "ViewTemplatesWkhtml"
	},
	{
		path: "/templates/email-mjml/:id",
		component: ViewTemplatesEmailMjml,
		name: "ViewTemplatesEmailMjml",
		props: true,
		meta: {}
	},
	{
		path: "/templates/pdf-drawing/:id",
		component: ViewTemplatesPdfDrawing,
		name: "ViewTemplatesPdfDrawing",
		props: true,
		meta: {}
	},
	{
		path: "/templates/notification/:id",
		component: ViewTemplatesNotification,
		name: "ViewTemplatesNotification",
		props: true,
		meta: {}
	},
	{
		path: "/templates/sms-notifications/:id",
		component: ViewTemplatesSms,
		name: "ViewTemplatesSms",
		props: true,
		meta: {}
	},
	{
		path: "/templates/dynamic/:id",
		component: ViewTemplatesDynamic,
		name: "ViewTemplatesDynamic",
		props: true,
		meta: {}
	},
	{
		path: "/templates/function/:id",
		component: ViewTemplatesFunction,
		name: "ViewTemplatesFunction",
		props: true,
		meta: {}
	}
]
